
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/ui-ux-design",
      function () {
        return require("private-next-pages/services/ui-ux-design.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/ui-ux-design"])
      });
    }
  